export default "__VITE_ASSET__Blaxevtm__"